import PropTypes from 'prop-types';
import React from 'react';

import HomeDashboardActions from 'home-dashboard/HomeDashboardActions';
import HomeDashboardStore from 'home-dashboard/HomeDashboardStore';
import SearchOrganizationModal from 'orgs/SearchOrganizationModal';
import EntityStore from 'stores/EntityStore';
import ModalAnchor from 'ui-library/ModalAnchor';

const _handleCloseSearchOrgModal = () => HomeDashboardActions.closeSearchOrgModal();

const AnchorModalsForOnboarding = ({openModal, searchOrgModalState}) => (
  <div>
    {EntityStore.currentUser() && (
      <div>
        <ModalAnchor open={openModal === HomeDashboardStore.SEARCH_ORGANIZATION_MODAL_KEY}>
          <SearchOrganizationModal
            currentUser={EntityStore.currentUser()}
            modalState={searchOrgModalState}
            onRequestClose={_handleCloseSearchOrgModal}
          />
        </ModalAnchor>
      </div>
    )}
  </div>
);

AnchorModalsForOnboarding.propTypes = {
  openModal: PropTypes.string,
  searchOrgModalState: PropTypes.object,
};

export default AnchorModalsForOnboarding;
